export default __webpack_public_path__ + "media/images/temporary/story-1-722eabea245c0d7e391afa64a7885cdd.jpg";